import { LoyaltyBarcodePaymentType } from './types';

export const LOYALTY_BARCODE_PREPAID_PAYMENT_TYPE_ID = LoyaltyBarcodePaymentType.TIM_CARD;
